import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography, Grid, Button, Hidden,
} from '@material-ui/core';
import { Translate } from 'react-localize-redux';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import TitleField from '../components/title-field';
import InfoCard from '../components/info-card';
import StyledTable from '../components/table/styled-table';
import CustomTableRow from '../components/table/custom-table-row';
import CustomTableCell from '../components/table/custom-table-cell';
import ListValues from '../components/list-values';
import ListMobile from '../components/list-mobile';
import LicenseList from '../components/license-list';
import {
  getElementBySysId, getControllersListCommaSep, formatDatePeriod, formatDate,
  getLicenseListFromLicenseSysIDs, sortByNewestDate, getWorkPlanStatusText,
} from '../utils';

class Assignment extends PureComponent {
  render() {
    const {
      classes, history, match: { params: { id } },
      assignments: { payload: assignmentsPayload },
      licenses: { payload: licensesPayload },
    } = this.props;

    const assignment = getElementBySysId(assignmentsPayload, id);

    const controlListLicenseSysIDs = (assignment != null && assignment.controlList != null)
      ? assignment.controlList.licenses : null;
    const licenses = getLicenseListFromLicenseSysIDs(licensesPayload, controlListLicenseSysIDs);

    if (assignment == null) {
      return (
        <div>
          {`Ingen kontrolloppdrag funnet med sysId: ${id}`}
        </div>
      );
    }

    return (
      <div>
        <TitleField
          title={assignment.controlList.name}
        />

        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">
                Opplysninger om oppdraget
              </Typography>
              <ListValues values={{
                titleControlList: assignment.controlList.name,
                zone: assignment.controlList.zone
                && assignment.controlList.zone.indexOf('sone') === 0
                  ? assignment.controlList.zone.substring(4)
                  : assignment.controlList.zone,
                assigned: getControllersListCommaSep(assignment.controllers),
                period: formatDatePeriod(assignment.fromDate, assignment.toDate),
                numberOfLicenses: assignment.controlList.licenses.length,
              }}
              />
            </Grid>
          </Grid>
        </InfoCard>

        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={9}>
              <Typography variant="h6" color="primary">
                Ny arbeidsplan
              </Typography>
              <Typography>
                Lag en ny arbeidsplan med stedene det planlegges å utføre kontroll på
                ila. en gitt dag.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3} className={classes.flex}>
              <div />
              <Button color="primary" variant="outlined" onClick={() => history.push(`oppdrag--${id}/ny-arbeidsplan`)}>
                Opprett ny arbeidsplan
              </Button>
            </Grid>
          </Grid>
        </InfoCard>

        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">
                Arbeidsplaner
              </Typography>
              {!assignment.workPlans && (
                <Typography>Ingen arbeidsplaner opprettet ennå.</Typography>
              )}
              {assignment.workPlans && (
                <>
                  <Hidden key="licenses-list" mdDown>
                    <StyledTable
                      header={[
                        <Translate id="workPlan.date" />,
                        <Translate id="workPlan.status" />,
                        '',
                      ]}
                      rowsPerPage={10}
                    >
                      {assignment.workPlans
                        && assignment.workPlans.sort(sortByNewestDate).map((workPlan, index) => (
                          <CustomTableRow
                            key={workPlan.sysId}
                            link={`/arbeidsplan--${workPlan.sysId}`}
                            odd={!(index % 2)}
                          >
                            <CustomTableCell>{formatDate(workPlan.date)}</CustomTableCell>
                            <CustomTableCell>
                              {getWorkPlanStatusText(workPlan)}
                            </CustomTableCell>
                            <CustomTableCell shrink>
                              <ArrowForwardIcon color="primary" />
                            </CustomTableCell>
                          </CustomTableRow>
                        ))}
                    </StyledTable>
                  </Hidden>
                  <Hidden lgUp>
                    <ListMobile
                      fetched
                      rowsPerPage={5}
                      content={assignment.workPlans
                          && assignment.workPlans.sort(sortByNewestDate).map(workPlan => ({
                            sysId: workPlan.sysId,
                            primary: formatDate(workPlan.date),
                            secondary: (
                              <>
                                <Typography component="span" variant="body1" display="block">
                                  {`Status: ${getWorkPlanStatusText(workPlan)}`}
                                </Typography>
                              </>
                            ),
                            onClick: () => {
                              history.push(`/oppdrag--${id}/arbeidsplan--${workPlan.sysId}`);
                            },
                          }))}
                    />
                  </Hidden>
                </>
              )}
            </Grid>
          </Grid>
        </InfoCard>

        <InfoCard elevation={2} className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">
                Bevillinger
              </Typography>
              <LicenseList
                licenses={licenses}
                showZone={false}
                workPlanList={assignment.workPlans}
                showIsControlCompleted
              />
            </Grid>
          </Grid>
        </InfoCard>
      </div>
    );
  }
}

const styles = () => ({
  bold: {
    fontWeight: 'bold',
  },
  card: {
    marginBottom: '1rem',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  paper: {
    padding: '0.8rem',
    paddingBottom: 0,
    border: '1px solid lightgray',
  },
  margin: {
    margin: '1rem 0',
  },
  marginTop: {
    marginTop: '3rem',
  },
});

Assignment.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
  assignments: PropTypes.object.isRequired,
  licenses: PropTypes.object.isRequired,
};

const mapStateToProps = ({ assignments, licenses }) => ({ assignments, licenses });

export default connect(mapStateToProps)(withRouter(withStyles(styles)(Assignment)));
